<app-modal
  #deleteAlertsModal
  [modalMessage]="app.text.alert.deleteMessage"
  [modalTitle]="app.text.alert.modalTitle"
  (ok)="(true)"
  >
</app-modal>

<!-- Quick filters -->
<div class="row">
  <div class="col-md-12">
    <button
      class="btn btn-sm btn-task my-2"
      [ngClass]="{ 'btn-default-orange': app.tasks.tasksTab === myOpenTasks }"
      (click)="app.tasks.setTasksTab(myOpenTasks)"
      >
      <i class="fas fa-tasks"></i>
      {{ app.text.post.myTasks }}
    </button>
    <button
      class="btn btn-sm btn-task my-2"
      [ngClass]="{
        'btn-default-orange': app.tasks.tasksTab === createdOpenTasks
      }"
      (click)="app.tasks.setTasksTab(createdOpenTasks)"
      >
      <i class="fas fa-list-ul"></i>
      {{ app.text.post.createdTasks }}
    </button>
    @if (app.permission.post.seeAllTasksTab) {
      <button
        class="btn btn-sm btn-task my-2"
      [ngClass]="{
        'btn-default-orange': app.tasks.tasksTab === allOpenTasks
      }"
        (click)="app.tasks.setTasksTab(allOpenTasks)"
        >
        <i class="fas fa-list-ul"></i>
        {{ app.text.post.allTasks }}
      </button>
    }
    <div class="dropdown quickFilters pull-right my-2">
      @if (app.permission.post.canExportTasks) {
        <button
          class="btn btn-sm btn-clean pull-right"
          (click)="app.tasks.exportData()"
          >
          <i class="fa fa-download"></i>&nbsp;
          {{ app.text.post.exportTasks }}
        </button>
      }
      <button
        class="btn dropdown-toggle"
        type="button"
        id="quickFilters"
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        >
        <div class="icon-center me-1">
          <i class="fas fa-eye menu-icons"></i>
        </div>
        <span>&nbsp;{{ app.text.home.showOnly }}&nbsp;</span>
        <span class="text-danger">
          {{
          app.filterFields.getQuickFilterText(app.tasks.quickFilterSelected)
          }}
        </span>
      </button>
      <div
        id="quickFiltersDropdown"
        class="dropdown-menu"
        aria-labelledby="quickFiltersDropdown"
        role="menu"
        >
        @for (item of app.tasks.quickFilters; track item) {
          <a
            class="dropdown-item pointer"
          (click)="
            app.tasks.addQuickFilter(item); app.tasks.quickFilterSelected = item
          "
            >{{ app.text.post[item] }}
          </a>
        }
      </div>
    </div>
  </div>
</div>

<app-paginator
  [length]="app.tasks.tasks.length"
  [index]="app.paginator.focus"
  (focus)="app.paginator.focus = $event"
></app-paginator>

<div class="tableFixHead">
  <table class="table table-striped spacing-table">
    <thead>
      <tr>
        @for (column of app.tasks.taskColumns; track column) {
          <th
            class="p-1"
            >
            <div
            (click)="
              app.table.toggleSortDirection('post.' + column);
              app.table.sort(app.tasks.tasks)
            "
              >
              @switch (column) {
                @case ('taskDueDate') {
                  <span>
                    {{ app.text.post.taskDueDate }}
                  </span>
                }
                @case ('completedAt') {
                  <span>
                    {{ app.text.post.closedOnDate }}
                  </span>
                }
                @case ('user_id') {
                  <span>
                    {{ app.text.post.creator }}
                  </span>
                }
                @default {
                  <span>
                    {{ app.field.getLabel("post." + column) }}
                  </span>
                }
              }
              @if ('post.' + column === app.table.sortField) {
                <span>
                  @if (app.table.sortDirection === 1) {
                    <i
                      class="fa fa-chevron-up"
                    ></i>
                  }
                  @if (app.table.sortDirection === -1) {
                    <i
                      class="fa fa-chevron-down"
                    ></i>
                  }
                </span>
              }
            </div>
            @if (app.filterTable.getFilterTableColumns(column)) {
              <div>
                <app-filter-table
                  [column]="column"
                  [columns]="app.tasks.taskColumns"
                  [docType]="'post'"
                  [cleanDocs]="app.tasks.cleanTasks"
                  [selectedFilters]="app.tasks.selectedFilters"
                  (resultedDocs)="app.filterTable.getFilterResults($event, 'task')"
                  [resetComponent]="app.tasks.resetFilterInputsObservable"
                  >
                </app-filter-table>
              </div>
            }
          </th>
        }
      </tr>
    </thead>
    <tbody>
      @for (task of app.paginator.getPage(app.tasks.tasks); track task) {
        <tr
          [ngClass]="{ isSelected: app.isSelected(task) }"
          class="pointer"
        (click)="
          app.routing.openInNewTab(null, 'thread.omfNumber', task.omfNumber)
        "
          >
          @for (column of app.tasks.taskColumns; track column) {
            <td
              class="py-1 px-2"
              >
              @switch (app.table.getColumnTypeDisplay(column)) {
                @case ('navigateAction') {
                  <div>
                    {{ task[column] }}
                  </div>
                }
                @case ('limit') {
                  <div class="d-flex">
                    <div [ngClass]="{ 'show-less': showShortDesciption }">
                      {{ task[column] }}
                    </div>
                    @if (task[column].length > 400) {
                      <button
                        class="btn"
                        type="button"
                        (click)="alterDescriptionText(); $event.stopPropagation()"
                        >
                        @if (showShortDesciption) {
                          <i
                            class="fas fa-chevron-down icon-style"
                          ></i>
                        }
                        @if (!showShortDesciption) {
                          <i
                            class="fas fa-chevron-up icon-style"
                          ></i>
                        }
                      </button>
                    }
                  </div>
                }
                @case ('dueDate') {
                  <div>
                    @if (task[column] > 0) {
                      <span
              [ngStyle]="
                app.tasks.getTaskDueDateColor(task[column], task.taskCompleted)
              "
                        >
                        {{ task[column] | date : "yyyy-MM-dd" : "UTC" }}
                      </span>
                    }
                  </div>
                }
                @case ('optionText') {
                  <div>
                    {{getOptionText(column, task[column])}}
                  </div>
                }
                @case ('getUser') {
                  <div>
                    {{ app.users.getOptionName(task[column]) }}
                  </div>
                }
                @case ('normal') {
                  <div>
                    @if (column === 'finalSolution') {
                      <div>
                        {{
                        app.field.getOptionText(
                        app.fieldId.post.resolveClass,
                        task[column]
                        )
                        }}
                      </div>
                    }
                    @if (column !== 'finalSolution') {
                      <div>
                        {{ task[column] }}
                      </div>
                    }
                  </div>
                }
                @case ('time') {
                  <div>
                    @if (task[column] > 0) {
                      <span>
                        {{ task[column] | date : "yyyy-MM-dd HH:mm:ss" }}
                      </span>
                    }
                  </div>
                }
              }
            </td>
          }
        </tr>
      }
      <tr>
        @if (app.tasks.loading) {
          <td colspan="99" class="text-center">
            {{ app.text.core.loading }}
          </td>
        }
        @if (!app.tasks.loading && app.tasks.tasks.length === 0) {
          <td
            colspan="99"
            class="text-center"
            >
            {{ app.text.app.noResults }}
          </td>
        }
      </tr>
    </tbody>
  </table>
</div>

<app-paginator
  [length]="app.tasks.tasks.length"
  [index]="app.paginator.focus"
  (focus)="app.paginator.focus = $event"
></app-paginator>
